// src/api/experienceService.ts
import api from './config';

export interface Experience {
  id?: number;
  title: string;
  company: string;
  location: string;
  date_start: string;
  date_end?: string | null;
  description: string;
  achievements?: string;
  is_current: boolean;
}

export const getExperiences = async (): Promise<Experience[]> => {
  // Updated path with /experience prefix
  const response = await api.get('/api/experience/');
  return response.data.data;
};

export const getExperienceById = async (id: number): Promise<Experience> => {
  // Updated path with /experience prefix
  const response = await api.get(`/api/experience/${id}`);
  return response.data.data;
};

export const createExperience = async (experience: Omit<Experience, 'id'>): Promise<Experience> => {
  // Updated path with /experience prefix
  const response = await api.post('/api/experience/', experience);
  return response.data.data;
};

export const updateExperience = async (id: number, experience: Partial<Experience>): Promise<Experience> => {
  // Updated path with /experience prefix
  const response = await api.put(`/api/experience/${id}`, experience);
  return response.data.data;
};

export const deleteExperience = async (id: number): Promise<void> => {
  // Updated path with /experience prefix
  await api.delete(`/api/experience/${id}`);
};
